/* ==========================================================================
   Utilities
   ========================================================================== */

import './ga4-event-tracker';